import { computed, inject, Service, signal } from '@angular/core';
import { IDienstleistungArtInfo } from '@mng/mgs-lib';
import { MgsWebApi } from '../mgs-webapi.service';

import { firstValueFrom } from 'rxjs';
import { IOption, withEmptyOption } from '@mng/mng-inputs';
import { sortArray } from '@mng/mng-ts-helpers';
import { MgsActiveState } from '../mgs-active.state';

@Service()
export class DienstleistungArtenService {
  readonly #mgsWebApi = inject(MgsWebApi);

  readonly activeState = inject(MgsActiveState);

  dienstleistungArten = signal<IDienstleistungArtInfo[]>([]);

  partnerDienstleistungArten = computed(() => {
    if (this.activeState.authState.isAdmin()) {
      return this.dienstleistungArten();
    } else {
      const result = this.dienstleistungArten().filter((dienstleistungsArt) =>
        this.activeState.partnerDienstleistungsartIds().includes(dienstleistungsArt.id)
      );
      return result;
    }
  });

  partnerDienstleistungsArtOptions = computed(() =>
    sortArray(
      this.partnerDienstleistungArten().map((art) => ({ name: art.label.toLowerCase(), value: art.id }) as IOption),
      (value) => value.name
    )
  );

  partnerDienstleistungsArtWithEmptyOptions = computed(() => withEmptyOption(this.partnerDienstleistungsArtOptions()));

  async initialize() {
    if (this.dienstleistungArten().length === 0) {
      this.dienstleistungArten.set(await firstValueFrom(this.#mgsWebApi.dienstleistungArten()));
    }
    return this.dienstleistungArten();
  }
}
